import { SMALL_SCREEN_WIDTH_LIMIT } from '@/common/constants';
import {useState, useEffect} from 'react'

const useSmallScreen = () => {

  const [width, setWidth] = useState(0);

  const handleWindowResize = () => {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    // component is mounted and window is available
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    // unsubscribe from the event on component unmount
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return (width < SMALL_SCREEN_WIDTH_LIMIT);

}

export default useSmallScreen;
